export default {
  LOGOUT({ commit }) {
    commit('SET_username', '');
    commit('SET_token', '');
  },
};
